module.exports = __webpack_public_path__ + "img/target.cdd08560.png";